<template>
  <auth-layout>
    <div class="w-full md:w-4/5 mx-auto text-darkBlue mt-24 px-3">
      <p class="text-sm pl-3 font-semibold text-center my-3">
        Enter verification code sent to your Email
      </p>
      <div class="w-full md:w-4/5 mx-auto mt-4">
        <form class="auth-code-form mt-4" @submit.prevent>
          <div class="flex items-center mx-auto sm:w-full">
            <div>
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="5"
                v-model="authenticationCode.first"
                @keyup="changeInputField"
                @paste="pasteCode($event)"
                autofocus
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.second"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.third"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.fourth"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.fifth"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.sixth"
                @keyup="changeInputField"
              />
            </div>
            <div class="verification-status" v-if="codeSubmitted">
              <div class="verification successful" v-if="successfullyVerified">
                <img
                  src="@/assets/images/checkmark.png"
                  alt="checkmark"
                  class="img-fluid"
                />
              </div>
              <div
                class="verification failed cursor-pointer"
                v-else
                @click="resetCodeFields"
              >
                <img
                  src="@/assets/images/cancel.png"
                  alt="checkmark"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <small class="mt-3" v-if="codeSubmitted && !successfullyVerified">
            <span
              class="text-primary-yellow cursor-pointer"
              @click="resendVerificationCode"
              >Resend code</span
            >.</small
          >

          <div class="mt-10 mb-8" v-if="!successfullyVerified">
            <base-button
              text="Submit"
              width="w-full"
              p="px-12 py-2"
              @click="verifyAuthenticationCode"
              :loading="loading"
            />
          </div>

          <div class="no-mail">
            <small>
              Didn't get the email?
              <span
                @click="resendVerificationCode"
                class="text-primary-yellow font-medium cursor-pointer"
              >
                Click here
              </span>
            </small>
          </div>
        </form>
      </div>
    </div>

    <template v-slot:text>
      <div class="text-white">
        <p class="text-sm">
          One last step and you are all good to go. An email with a verification
          code has been sent to you
        </p>
      </div>
    </template>
  </auth-layout>
</template>

<script>
import AuthLayout from "../Authlayout/OnDemand";
import changeInputField from "@/mixins/changeInput";

export default {
  components: {
    AuthLayout,
  },

  data() {
    return {
      authenticationCode: {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      },
      password: "",
      password_confirmation: "",
      verifyingAuthCode: false,
      isCreatePassword: false,
      codeSubmitted: false,
      loading: false,
      successfullyVerified: false,
      verificationResent: false,
      resendingVerificationCode: false,
      codeVerified: false,
      userEmail: {},
    };
  },
  mounted() {
    console.log("===>>>>>>", JSON.parse(localStorage.getItem("loginPayload")).data.data)
  },
  mixins: [changeInputField],
  methods: {
    async verifyAuthenticationCode() {
      try {
        this.loading = true;

        const payload = {
          token: this.convertAuthCodeToNumbers(),
          userId: localStorage.getItem("userId"),
          quantumToken: localStorage.getItem("quantumToken"),
        };

        const response = await this.$_loginWithToken(payload);

        this.handleSuccessfulResponse(response);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    async resendVerificationCode() {
      this.generateToast("Resending...", "success");

      try {
        let userId = localStorage.getItem("userId");
        let loginPayload = JSON.parse(localStorage.getItem("loginPayload"));
        let response = await this.$_resendVerificationCode(userId, loginPayload?.data?.data?.email);
        this.handleSuccessfulCodeResend();
        this.log(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    handleSuccessfulCodeResend() {
      this.resendingVerificationCode = false;
      this.codeSubmitted = false;
      this.verificationResent = true;
      this.generateToast(
        "A new verification code has been sent to your email address!",
        "success"
      );
    },
    convertAuthCodeToNumbers() {
      let {
        first,
        second,
        third,
        fourth,
        fifth,
        sixth,
      } = this.authenticationCode;
      let authCodeNumbers = first + second + third + fourth + fifth + sixth;
      return authCodeNumbers;
    },
    handleSuccessfulResponse({ data: response }) {
      this.$store.dispatch("handleSuccessfulLogin", response.data);

      if (response.data.user.onboardingtype === "ondemand") {
        this.$router.push("/dashboard");
      } else {
        this.$router.push("/3pl/dashboard");
      }
    },

    resetCodeFields() {
      this.authenticationCode = {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      };
    },
    pasteCode(e) {
      e.preventDefault();
      const code = e.clipboardData.getData("text/plain");

      if (code.length == 6) {
        this.authenticationCode = {
          first: code.charAt(0),
          second: code.charAt(1),
          third: code.charAt(2),
          fourth: code.charAt(3),
          fifth: code.charAt(4),
          sixth: code.charAt(5),
        };
      } else {
        this.generateToast("Invalid code entered!", "error");
        this.authenticationCode.first = "";
      }
    },
  },
};
</script>

<style scoped>
.single-code-input {
  width: 3.5rem;
  height: 3.75rem;
  background: #ffffff;
  border: 1px solid #b8c4de;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 1rem;
  margin: 0 0.55rem;
  margin-bottom: 7px;
}

.single-code-input::placeholder {
  font-weight: normal;
  font-size: 1rem;
}

.single-code-input[type="text"] {
  font-size: 2.3rem;
  text-align: center;
  font-weight: bold;
  color: rgba(82, 82, 82, 0.3);
}
</style>
